import styled from 'styled-components';

const Body = styled.div`
  display: flex;
  width: 55%;
`;

export default Body;



// WEBPACK FOOTER //
// ./src/components/Gui/styled/Body.js